
// https://image-compare-viewer.netlify.app

//import ImageCompare from "image-compare-viewer";

import ImageCompare    from './../../libs/image-compare/imageCompare';


export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 'image-compare';
		this.$el 			= this.options.$el;
		this.main			= this.options.main;

        //this.$play_btn      = this.$el.find('A[rel="before-after:play"]');
        this.playing        = false;

		this.init();

        setTimeout( ()=>{
            this.$el.addClass('init');
        }, 17 )

    }

    init(){

        // console.log('imageCompare -- init');

        //console.log( this.$play_btn );
        this.viewer = new ImageCompare( this.$el.find( '.image-compare' )[0], {

            // UI Theme Defaults

            controlColor: "#FFFFFF",
            controlShadow: true,
            addCircle: false,
            addCircleBlur: false, //true,

            // Label Defaults

            showLabels: false,
            labelOptions: {
            before: 'Before',
            after: 'After',
            onHover: false
            },

            // Smoothing

            smoothing: true,
            smoothingAmount: 100,

            // Other options

            hoverStart: false,
            verticalMode: false,
            startingPoint: 50,
            fluidMode: true, //false        

            /* NOTE: if you put fluidMode false (default) the image is set to the REAL size of the image, so in order to make it work you have to eliminate the img-wrapper from the widget */

        });

        this.viewer.mount();
       
        //this.$play_btn      = this.$el.find( '.twentytwenty-handle' ); //this.$el.find('A[rel="before-after:play"]');

        //this.addEvents( true );

	}

    addEvents( b ){
        if ( b ){
            this.$play_btn.on( 'click', (e) => this.togglePlay(e) );
        }
        else{
            this.$play_btn.off( 'click', (e) => this.togglePlay(e) );
        }
    }

    togglePlay(e){
        e.preventDefault();

        console.log( 'togglePlay' );

        if (this.playing) {
            this.playing = false;
        } else {

            console.log('START PLAYING: Animate clip path on images and move the handle');

        }

        return false;
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        if ( this.$el.length > 0 ){
            // this.addEvents( false );
            this.$el.removeData();
        }
    }

}